// extracted by mini-css-extract-plugin
export default {"userNavigate":"userNavigate_userNavigate__39vDc","titleWrap":"userNavigate_titleWrap__u9BcE"};